export enum OrderStatus {
  New,
  ToPickup,
  PickupInProgress,
  ReceivedFromSeller,
  ReceivedFromCarrier,
  ToPay,
  InComplaint,
  Paid,
  ForSale,
  Sold
}
